module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAA/klEQVQoU33RIUueYRTG8d9VRCyaZB9BxGKzKCiDFfMGLgiCScGiQQRRwTKD0SiDpcHAqgONIgjCWDT4ATQ5Z/PIA77y8qDvgZPO/T/nuq47VbWGBTx5vzaSHDXjVNXfJGPvva2qARwnmewAV0nGq2oIgy3wNslDVZ0lmW4Dm/jSAraT/HwT6KFfVZ0mmWlfmMB4C/yd5LqqhnGf5LEx3fHwASMt4DLJv6o6xyi+vQI9UvqE7y/+drov7OJz2zSWsIJDrHcD/Wi6uz5iCnv4gemekqrqBPPYwq8kJw3wB1/xv2t14QYX2MdcktlOrM2XL6OvJWcVB7jDYpNWM38GrK2BjuwibeEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_f3.png
// module id = M2IY
// module chunks = 14 17